var map = {
	"./caimao.svg": "ea8c",
	"./ciidee.svg": "07f1",
	"./hupo.svg": "365f",
	"./jooyum.svg": "d6ca",
	"./logo.svg": "136c",
	"./mg.svg": "9364",
	"./mongo.svg": "ab47",
	"./s2p.svg": "f26a",
	"./xst.svg": "ab74"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7338";